export default __webpack_public_path__ + "static/media/G0780.34I-36923_-22032_0.1654023360000.87f52a75.jpg";